import {FormControl, InputLabel, makeStyles, MenuItem, Select} from '@material-ui/core';
import React, { useState } from 'react';
import { useEffectAsync } from '../reactHelper';
import {cyberStyles} from "../cssShared/cyberTheme";

const useStyles = makeStyles((theme) => ({
  ...cyberStyles(theme),
}));

const SelectField = ({
  margin,
  variant,
  label,
  multiple,
  value,
  emptyValue = 0,
  onChange,
  endpoint,
  data,
  keyGetter = item => item.id,
  titleGetter = item => item.name,
}) => {
  const classes = useStyles();
  const [items, setItems] = useState(data);

  useEffectAsync(async () => {
    if (endpoint) {
      const response = await fetch(endpoint);
      if (response.ok) {
        setItems(await response.json());
      }
    }
  }, []);

  if (items) {
    return (
      <FormControl margin={margin} variant={variant} className={classes.formControl}>
        <InputLabel>{label}</InputLabel>
        <Select
          multiple={multiple}
          value={value}
          onChange={onChange}
          MenuProps={{PaperProps: { className: classes.periodMenuPaper },}}
        >
          {!multiple && emptyValue !== null &&
            <MenuItem value={emptyValue} className={classes.menuItem}>&nbsp;</MenuItem>
          }
          {items.map(item => (
            <MenuItem key={keyGetter(item)} value={keyGetter(item)} className={classes.menuItem}>{titleGetter(item)}</MenuItem>
          ))}
        </Select>
      </FormControl>
    );
  } else {
    return null;
  }
}

export default SelectField;
